module.exports = __webpack_public_path__ + "img/avata-default.b0bd6ab2.jpg";